export const ActionKeys = {
  REQUEST_WELCOME_MESSAGE: "REQUEST_WELCOME_MESSAGE",
  RECEIVE_WELCOME_MESSAGE: "RECEIVE_WELCOME_MESSAGE"
};
